import * as React from 'react'

import { TestableInterface } from '../interfaces/TestableInterface'
import { makeTranslatable, TranslatableType } from '../interfaces/Translatable'
import './CheckBox.scss'

export interface CheckBoxProps extends TestableInterface {
  value: boolean
  label?: TranslatableType
  onChange?: (value: boolean, e?) => void
  className?: string
  labelPosition?: 'left' | 'right'
  disabled?: boolean
}

class CheckBox extends React.Component<CheckBoxProps, null> {
  private renderLabel(): JSX.Element {
    if (this.props.label) {
      return (
        <span data-automation={this.props.automation + '-label'} className="Label">
          {makeTranslatable(this.props.label)}
        </span>
      )
    }
    return <></>
  }

  private change(e) {
    this.props.onChange?.(!this.props.value, e)
  }

  public render(): JSX.Element {
    const classes = ['Controlled', 'Input', 'CheckBox']
    if (this.props.labelPosition === 'left') {
      classes.push('labelLeft')
    }
    if (this.props.className) {
      classes.push(this.props.className)
    }
    if (this.props.disabled) {
      classes.push('disabled')
    }
    const checkClasses = ['check']
    if (this.props.value) {
      checkClasses.push('checked')
    }
    if (this.props.disabled) {
      checkClasses.push('checkDisabled')
    }
    if (this.props.labelPosition === 'left') {
      return (
        <div
          role="checkbox"
          aria-checked={this.props.value ? 'true' : 'false'}
          className={classes.join(' ')}
          value={this.props.value ? 'true' : 'false'}
          onClick={(e) => {
            this.change(e)
          }}
        >
          {this.renderLabel()}
          <div className={checkClasses.join(' ')} data-automation={this.props.automation}>
            &nbsp;
          </div>
        </div>
      )
    } else {
      return (
        <div
          role="checkbox"
          aria-checked={this.props.value ? 'true' : 'false'}
          className={classes.join(' ')}
          value={this.props.value ? 'true' : 'false'}
          onClick={(e) => {
            this.change(e)
          }}
        >
          <div className={checkClasses.join(' ')} data-automation={this.props.automation}>
            &nbsp;
          </div>
          {this.renderLabel()}
        </div>
      )
    }
  }
}

export default CheckBox
